import { Fragment } from 'react';
import { Header } from 'components/lib';
import Style from './public.module.scss';

export function PublicLayout(props) {

  // context & style
  return (
    <Fragment>

      <main className={Style.appPlain}  style={{ marginTop: "2em" }}>
        <Header title={props.title}>
        </Header>

        {<props.children {...props.data} />}

      </main>
    </Fragment>
  );
}